import React from 'react';
import moment from 'moment';

class TimeCountDown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            remainingTime: null
        }

        this.date = null;
        this.timer = null;
    }

    formatRemainingTimeString({remainingHours, remainingMinutes, remainingSeconds}) {
        let [years, months, days, hours, minutes, seconds] = [null, null, null, remainingHours, remainingMinutes, remainingSeconds];
        const hoursInDay = 24;
        const hoursInYear = (24 * 365);
        const hoursInMonth = (hoursInYear / 12);
        if (remainingHours >= hoursInYear) {
            years = parseInt(remainingHours / hoursInYear, 10);
            hours = remainingHours % hoursInYear;
        }
        if (hours >= hoursInMonth) {
            const clonedHours = hours * 1;
            months = parseInt(clonedHours / hoursInMonth, 10);
            hours = remainingHours % hoursInMonth;
        }
        if (hours >= hoursInDay) {
            const clonedHours = hours * 1;
            days = parseInt(clonedHours / hoursInDay, 10);
            hours = remainingHours % hoursInDay;
        }
        const stringItems = [];
        if (years) {
            const str = years == 1 ? `${years} Year` : `${years} Years`;
            stringItems.push(str);
        }
        if (months) {
            const str = months == 1 ? `${months} Month` : `${months} Months`;
            stringItems.push(str);
        }
        if (days) {
            const str = days == 1 ? `${days} Day` : `${days} Days`;
            stringItems.push(str);
        }
        if (hours) {
            const str = hours == 1 ? `${hours} Hour` : `${hours} Hours`;
            stringItems.push(str);
        }
        if (minutes) {
            const str = minutes == 1 ? `${minutes} Minute` : `${minutes} Minutes`;
            stringItems.push(str);
        }
        if (seconds && !stringItems.length) {
            const str = seconds == 1 ? `${seconds} Second` : `${seconds} Seconds`;
            stringItems.push(str);
        }

        return stringItems.length ? stringItems.join(', ') : ''
    }
    updateTimer() {
        const date = this.date;
        const currentTime = moment().unix();
        const expiryTime = moment(date).unix();

        if (currentTime > expiryTime) {
            this.setState({ remainingTime: 'Expired' });
            return;
        }

        let remainingSeconds = expiryTime - currentTime;
        const secondsInMinute = 60;
        const secondsInHour = 60 * secondsInMinute;

        const remainingHours = remainingSeconds > secondsInHour ? parseInt(remainingSeconds / secondsInHour) : 0;
        remainingSeconds = remainingSeconds > secondsInHour ? parseInt(remainingSeconds % secondsInHour) : remainingSeconds;
        const remainingMinutes = remainingSeconds > secondsInMinute ? parseInt(remainingSeconds / secondsInMinute) : 0;
        remainingSeconds = remainingSeconds > secondsInMinute ? parseInt(remainingSeconds % secondsInMinute) : remainingSeconds;
        const attachZero = (number) => {
            if (number <= 9) {
                return `0${number}`;
            }
            return number;
        }
        const remainingTime = `${attachZero(remainingHours)}:${attachZero(remainingMinutes)}:${attachZero(remainingSeconds)}`;
        const remainingTimeString = this.formatRemainingTimeString({remainingHours, remainingMinutes, remainingSeconds});
        this.setState({ remainingTime, remainingTimeString });
        this.timer = setTimeout(() => { this.updateTimer(date) }, 1000)
    }
    componentDidMount() {
        const { date } = this.props;
        this.date = date;
        this.updateTimer();
    }

    componentDidUpdate() {
        const { date } = this.props;
        if(date && date != this.date) {
            this.date = date;
        }
    }

    componentWillUnmount(){
        clearTimeout(this.timer);
    }
    render() {
        const { remainingTime, remainingTimeString } = this.state;
        if (!remainingTime) {
            return null;
        }
        return (
            <div>{remainingTimeString}</div>
        )
    }
}

export default TimeCountDown;